import mitt from "mitt";

/**
 * Events published when the device's practice settings are saved.
 *
 * The live bridge session is configured once at boot, so a setting the
 * heartbeat reports — the device name, the KIM address override — would
 * otherwise keep sending its boot-time value until the app restarts. On a
 * kiosk that is weeks, during which the practice sees an address the device no
 * longer uses.
 *
 * @since 1.1.0
 */
export interface PracticeSettingsSaved {
  readonly deviceName?: string;
  /** Empty string means the device no longer overrides the practice address. */
  readonly kimAddressOverride: string;
}

/**
 * Event map for {@link practiceSettingsEmitter}.
 *
 * @since 1.1.0
 */
export type PracticeSettingsEvents = {
  "practice-settings:saved": PracticeSettingsSaved;
};

/**
 * Emitter carrying saved practice settings to the live bridge session.
 *
 * @since 1.1.0
 * @example
 * ```ts
 * practiceSettingsEmitter.emit("practice-settings:saved", {
 *   kimAddressOverride: "praxis@musterpraxis.kim.telematik",
 * });
 * ```
 */
export const practiceSettingsEmitter = mitt<PracticeSettingsEvents>();
